// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getMessaging, isSupported } from "firebase/messaging";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyClDYDNky2XutoHgKK383b3xi67CXYa9jM",
  authDomain: "majimaji1o.firebaseapp.com",
  projectId: "majimaji1o",
  storageBucket: "majimaji1o.firebasestorage.app",
  messagingSenderId: "523906009562",
  appId: "1:523906009562:web:b59f2de5ed4197ca6958e3",
  measurementId: "G-4G8XMM14ER"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Cloud Storage and get a reference to the service
const storage = getStorage(app);
const db = getFirestore(app);
const auth = getAuth(app);

// Initialize Firebase Cloud Messaging only if the browser supports it
let messaging = null;
isSupported()
  .then((supported) => {
    if (supported) {
      messaging = getMessaging(app);
    } else {
      console.warn("Firebase Messaging is not supported in this browser/context.");
    }
  })
  .catch((err) => {
    console.warn("Error checking Firebase Messaging support:", err);
  });

export { app, storage, db, auth, messaging };